import { useEffect, useRef, useState } from "react";
import DataGrid, {
  Column,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";
import { Template } from "devextreme-react";
import { reportService } from "../../../apis/apiServices/Report";
import { DefaultDateFormat } from "../../../helper/fixcode";
import { Loader } from "../../Shared/PageLoader";
import "./../../../App.css";

export default function ReportAssetAttachmentComponent() {
  const [dataSource, setDataSource] = useState([]);
  const refDataGrid = useRef(null);
  const [state, setState] = useState({
    isCompleteLoading: false,
    loadingMessage: "Loading Report...",
  });

  useEffect(() => {
    const el = document.querySelector("#pageTitle");
    if (el) el.innerHTML = "Asset Attachment Report";
    fetchReportData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchReportData = async () => {
    try {
      //refDataGrid?.current?.instance?.beginCustomLoading?.();
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: true,
      }));
      const result = await reportService.getAssetAttachmentReport();
      const list = result?.data ?? result ?? [];
      setDataSource(Array.isArray(list) ? list : []);
    } catch (error) {
      console.error("fetchReportData error:", error);
      setDataSource([]);
    } finally {
      //refDataGrid?.current?.instance?.endCustomLoading?.();
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: false,
      }));
    }
  };

  const writeTabDownloadPage = (tab, fileUrl, filename) => {
    try {
      const safeFilename = (filename || "download").replace(/"/g, "");
      const page = `<!doctype html>
      <html>
      <head>
        <meta charset="utf-8" />
        <title>${safeFilename}</title>
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <style>html,body{height:100%;margin:0;background:#fff;display:flex;align-items:center;justify-content:center;font-family:Arial}#msg{max-width:90%;text-align:center}</style>
      </head>
      <body>
        <div id="msg">Preparing download...</div>
        <script>
          (async function(){
            const msg = document.getElementById('msg');
            try {
              const resp = await fetch(${JSON.stringify(
                fileUrl
              )}, { method: 'GET', mode: 'cors', credentials: 'same-origin' });
              if (!resp.ok) throw new Error('Fetch failed: ' + resp.status);
              const blob = await resp.blob();
              const blobUrl = URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = blobUrl;
              a.download = ${JSON.stringify(safeFilename)};
              document.body.appendChild(a);
              a.click();
              a.remove();
              msg.textContent = 'Download started. If not, please check browser download settings.';
              setTimeout(() => { try { URL.revokeObjectURL(blobUrl); } catch(e){} }, 3000);
            } catch (err) {
              msg.textContent = 'Could not fetch file directly (CORS/network). Redirecting to file URL...';
              try {
                window.location.href = ${JSON.stringify(fileUrl)};
              } catch(e) {
                msg.textContent = 'Unable to redirect. Please open the file URL manually.';
              }
            }
          })();
        </script>
      </body>
      </html>`;

      tab.document.open();
      tab.document.write(page);
      tab.document.close();
    } catch (e) {
      try {
        tab.location.href = fileUrl;
      } catch (err) {
        console.warn("writeTabDownloadPage fallback failed", err);
      }
    }
  };

  const handleDownload = (row) => {
    const url = row?.fileUrl;
    const filename = row?.assetFileName || "download";
    if (!url) {
      alert("No file URL available for download.");
      return;
    }

    const openedTab = window.open("", "_blank");

    if (!openedTab) {
      window.open(url, "_blank", "noopener,noreferrer");
      return;
    }

    writeTabDownloadPage(openedTab, url, filename);
  };

  const renderDownloadCell = (cellData) => {
    const row = cellData?.data;
    return (
      <button
        className="btn btn-outline-primary btn-sm"
        title="Download"
        onClick={(e) => {
          e.preventDefault();
          handleDownload(row);
        }}
        style={{
          padding: "2px 4px",
          minWidth: 28,
          height: 28,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <i className="fas fa-download" style={{ fontSize: "12px" }} />
      </button>
    );
  };

  // renderStatusCell: show colored status text
  // Active -> green, Expired -> red, Due (or contains "due") -> orange
  // keep other statuses default color
  const renderStatusCell = (cellData) => {
    const raw = (cellData?.data?.status ?? cellData?.value ?? "") + "";
    const text = raw.toString();
    const lower = text.toLowerCase();
    let color = "#6c757d"; // default muted
    if (lower.includes("active")) color = "green";
    else if (lower.includes("expired")) color = "red";
    else if (lower.includes("due")) color = "orange";
    return (
      <span style={{ color, fontWeight: 600 }}>
        {text}
      </span>
    );
  };

  return (
    <>
      <div className="content">
        <div className="card">
          <div className="card-body">
            <DataGrid
              ref={refDataGrid}
              keyExpr="id"
              dataSource={dataSource}
              showColumnLines={false}
              showRowLines={true}
              showBorders={true}
              allowColumnResizing={true}
              allowColumnReordering={true}
              columnAutoWidth={true}
              onToolbarPreparing={(e) => {
                e.toolbarOptions.items.unshift(
                  { location: "before", template: "toolbarRefreshTemplate" },
                  { location: "before", template: "toolbarBackTemplate" }
                );
              }}
            >
             
              <Column
                caption=""
                width={45}
                allowExporting={false}
                allowFiltering={false}
                allowSorting={false}
                allowSearch={false}
                cellRender={renderDownloadCell}
              />

              
              <Column dataField="assetSerialNo" caption="Asset Serial" />
              <Column dataField="assetName" caption="Asset Name" />

             
              {/* <Column dataField="assetFileName" caption="File Name" /> */}
              {/* <Column dataField="fileType" caption="File Type" width={140} /> */}
              {/* <Column
                dataField="fileSize"
                caption="File Size (bytes)"
                alignment="center"
              /> */}

              <Column dataField="fileTypeName" caption="File Type Name" />
              <Column
                dataField="fileCategoryName"
                caption="Document Category"
              />
              <Column dataField="fileDocumentNo" caption="Document No" />

           
              {/* <Column
                dataField="uploadDate"
                caption="Upload Date"
                dataType="date"
                format={DefaultDateFormat.GridDateFormat}
                width={140}
              /> */}
              <Column
                dataField="issueDate"
                caption="Issue Date"
                dataType="date"
                format={DefaultDateFormat.GridDateFormat}
                width={140}
              />
              <Column
                dataField="expiryDate"
                caption="Expiry Date"
                dataType="date"
                format={DefaultDateFormat.GridDateFormat}
                width={140}
              />
                {/* ✅ NEW COLUMN inserted here */}
              <Column
                dataField="daysToRenew"
                caption="Days To Renew"
                alignment="center"
                width={140}
              />

              {/* status column with colored text */}
              <Column dataField="status" caption="Status" cellRender={renderStatusCell} />

              <HeaderFilter visible={false} />
              <SearchPanel
                visible={true}
                width={300}
                placeholder="Search..."
              />
              <Column
                dataField="reminderAlertDays"
                caption="Reminder (days)"
                alignment="center"
                width={120}
              />
              <Column dataField="remark" caption="Remark" />

              
              <Paging defaultPageSize={15} />
              <Pager displayMode="compact" showInfo={true} />

              <Export enabled={true} fileName="AssetAttachmentReport" />

              <Template
                name="toolbarRefreshTemplate"
                render={() => (
                  <button
                    className="btn btn-outline-primary btn-sm"
                    onClick={fetchReportData}
                    type="button"
                  >
                    <i className="fas fa-sync-alt" />
                    &nbsp;Refresh
                  </button>
                )}
              />

              <Template
                name="toolbarBackTemplate"
                render={() => (
                  <button
                    className="btn btn-outline-primary btn-sm"
                    onClick={() => (window.location.href = "/reports")}
                    type="button"
                  >
                    <i className="fas fa-arrow-left" />
                    &nbsp;Back
                  </button>
                )}
              />
            </DataGrid>
          </div>
        </div>
      </div>

      {state.isCompleteLoading && (
        <Loader loadingMessage={state.loadingMessage} />
      )}
    </>
  );
}
